import { render, staticRenderFns } from "./yz_ws_guidang.vue?vue&type=template&id=0472f9c5&scoped=true"
import script from "./yz_ws_guidang.vue?vue&type=script&lang=js"
export * from "./yz_ws_guidang.vue?vue&type=script&lang=js"
import style0 from "./yz_ws_guidang.vue?vue&type=style&index=0&id=0472f9c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472f9c5",
  null
  
)

export default component.exports